import { axiosHttpClient } from "../axios";
import handleStatusCases from "../handle-status-cases";

const { REACT_APP_BASE_URL } = process.env;

type TCreateLevelAnnotation = {
    budgetId: string;
    levelId: string;
    params: {
        comment: string;
    };
};

export default async ({
    budgetId,
    levelId,
    params,
}: TCreateLevelAnnotation) => {
    const tempHeaders = {
        auth: true,
    };

    const httpRequest = await axiosHttpClient({
        url: `${REACT_APP_BASE_URL}/budget/${budgetId}/level/${levelId}/comment`,
        method: "post",
        body: params,
        headers: tempHeaders,
    });
    const { body, statusCode } = httpRequest;

    return handleStatusCases({ body, statusCode });
};
